import React, { Component } from 'react'

class PublicComponent extends Component{
      
  constructor(props) {
    super(props);
    this.startQuote = this.startQuote.bind(this);
  
  }
  startQuote(e) {
    e.preventDefault();
    this.props.history.push("/Auto");
            
  }

    render() {
        return(
          <React.Fragment>
            <div class="text-center py-4 my-3" style={BackGImtyle}>
            <div class="container">
              <div class="row rounded shadow p-1" style={BackGRowStyle}>
                <div class="mx-auto col-lg-5 col-md-7 col-10">
                  <h3 class="display-4">Devis rapide !</h3>
                  <p class="mb-3">En moins de 5 minutes. Assurance Auto, Habitation et bien d'autres...</p> 
                  <button class="btn btn-info" onClick={this.startQuote} ><i class="fa fa-fw fa-hand-o-right" ></i>Commencez maintenant</button>
                </div>
              </div>
            </div>
          </div>
          <div class="py-3 text-center">
            <div class="container">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h3 class="display-4 text-secondary">C'est simple et intuitif</h3>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-3 col-6 p-4"> <i class="d-block fa fa-3x mb-2 text-body fa-indent"></i>
                  <h4> <b>1</b> </h4>
                  <p>Sélectionner le type d'assurance : Auto, Habitation...etc</p>
                </div>
                <div class="col-lg-3 col-6 p-4"> <i class="d-block fa fa-3x mb-2 fa-info-circle text-warning"></i>
                  <h4> <b>2</b> </h4>
                  <p>Saisissez les informations sur le risque que vous désirez assurer</p>
                  <p>Dites nous un peu plus sur vous : âge, historique des sinistres...etc</p>
                </div>
                <div class="col-lg-3 col-6 p-4"> <i class="d-block fa fa-3x mb-2 fa-files-o text-primary"></i>
                  <h4> <b>3</b> </h4>
                  <p>Choisissez l'offre d'assurance qui vous convient le plus ou sélectionnez librement vos garanties</p>
                </div>
                <div class="col-lg-3 col-6 p-4"> <i class="d-block fa fa-3x mb-2 text-success fa-check-circle"></i>
                  <h4> <b>4</b> </h4>
                  <p>Valider le devis pour calculer la prime estimative de votre assurance. Vous pouvez aussi l'enregistrer dans votre espace client gratuit !</p>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
        );
    }
}

const BackGRowStyle = {
    backgroundColor: 'rgba(242,249,255,0.85)'
  }
  
const BackGImtyle = {
    'background-image': 'url(StartQuoteBg.png)',
    'background-position' : 'top left',
    'background-size': 'cover',
    'background-repeat': 'no-repeat'
  }

export default PublicComponent;